export interface MapAddressResult {
  id: string
  display: string
  city: string | null
  postcode: string | null
  country: string | null
  lat: number
  lon: number
}

export interface ParsedCoordinate {
  lat: number
  lng: number
}

export function parseLatLon(input: string): ParsedCoordinate | null {
  const match = input.trim().match(/^(-?\d{1,2}(?:\.\d+)?)[,;\s]+(-?\d{1,3}(?:\.\d+)?)$/)
  if (!match) return null

  const lat = Number.parseFloat(match[1])
  const lng = Number.parseFloat(match[2])
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null
  return { lat, lng }
}

export function formatAddressSubtitle(result: MapAddressResult): string {
  const place = [result.city, result.postcode, result.country].filter(Boolean).join(' · ')
  const coordinates = `${result.lat.toFixed(5)}, ${result.lon.toFixed(5)}`
  return place ? `${place} · ${coordinates}` : coordinates
}
